import { apiGet, apiPut } from '@/shared/utils/requestBuilder';
import type {
  ColunaDisponivel,
  PreferenciaColunas,
  ListColunasDisponiveisResponse,
  GetPreferenciaResponse,
} from '../types';

const parseJson = async <T>(response: Response, defaultMsg: string): Promise<T> => {
  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as { error?: string } | null;
    throw new Error(body?.error ?? defaultMsg);
  }
  return (await response.json()) as T;
};

export const negociacaoColunasService = {
  listDisponiveis: async (): Promise<ColunaDisponivel[]> => {
    const response = await apiGet('/negociacao/colunas/disponiveis');
    const body = await parseJson<ListColunasDisponiveisResponse>(
      response,
      'Erro ao carregar colunas disponíveis',
    );
    return body.data;
  },

  getPreferencia: async (): Promise<PreferenciaColunas> => {
    const response = await apiGet('/negociacao/colunas/preferencia');
    const body = await parseJson<GetPreferenciaResponse>(
      response,
      'Erro ao carregar preferência de colunas',
    );
    return body.data;
  },

  putPreferencia: async (fieldIds: string[]): Promise<PreferenciaColunas> => {
    const response = await apiPut('/negociacao/colunas/preferencia', { fieldIds });
    const body = await parseJson<GetPreferenciaResponse>(
      response,
      'Erro ao salvar preferência de colunas',
    );
    return body.data;
  },
};
